import {
  StaffInvitationResolveActions,
  StaffInvitationResolveTypeEnum,
} from './staff-invitation-resolve.types';

export class StaffInvitationProcessBatchResponseDto {
  success: number;
  failed: number;
  succesfullyProcessed: { email: string }[];
  errors: {
    email: string;
    index: number;
    type: StaffInvitationResolveTypeEnum;
    originalData: StaffInvitationResolveActions;
  }[];
}
